module.exports = __webpack_public_path__ + "img/svg - only person.b77410af.svg";